import Vue from "vue";

const JDataTableSetting = {
    // Type params
    // Type: https://datatables.net/reference/option/columns.type
    column(setting = { type, name, data, defaultContent, render, i18nName, tooltip, width }) {
        const { type, name, data, defaultContent, render, i18nName, tooltip, width } = setting;
        return {
            name,
            data,
            defaultContent,
            render,
            i18nName,
            tooltip, 
            width,
            type,
        };
    },
};

export default JDataTableSetting;





// WEBPACK FOOTER //
// ./src/components/Datatable/JDataTable.js